module.exports = __webpack_public_path__ + "img/mobile_t21.5d76295e.png";